import NoticeHub from './notice-hub';

export default NoticeHub;
